export default "__VITE_ASSET__BT8oF8ES__"